import React from "react";
import { MessageCircle } from "lucide-react";
import { waLink } from "../lib/whatsapp";

export const FloatingWhatsapp = () => {
  return (
    <a
      href={waLink("Olá Avantech! Vim pelo site e gostaria de falar com vocês.")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Falar no WhatsApp"
      className="fixed bottom-6 right-6 z-[60] bg-[#25D366] text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-transform flex items-center justify-center cursor-pointer wa-pulse"
    >
      <MessageCircle size={28} strokeWidth={2} />
      <span className="sr-only">WhatsApp</span>
    </a>
  );
};

export default FloatingWhatsapp;
